import React, { SyntheticEvent, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import styles from './ConfirmPopup.module.scss';
import { CompletedRegistrationBlock } from './components/CompletedRegistrationBlock';
import { ValidationBlock } from './components/ValidationBlock';
import { ConfirmPopupProps } from './types';

function ConfirmPopup({
  validationBlockTitle,
  validationBlockWarning,
  isVisible,
  isSent,
  isAfterWeb = false,
  onClose,
  onValidationSuccess,
  onValidationFailure,
}: ConfirmPopupProps) {
  const isValidationBlockVisible = !isSent && isVisible;
  const isCourseRegistrationCompleted = isSent && isVisible;

  const nodeRef = useRef<HTMLDivElement | null>(null);

  const onClick = (e: SyntheticEvent) => {
    if (e.target === nodeRef.current) {
      onClose();
    }
  };

  return (
    <CSSTransition
      in={isVisible}
      nodeRef={nodeRef}
      timeout={300}
      classNames={{
        enter: styles.popupBackground_enter,
        enterActive: styles.popupBackground_enterActive,
        exitActive: styles.popupBackground_exitActive,
        exit: styles.popupBackground_exit,
      }}
      unmountOnExit
    >
      <div ref={nodeRef} className={styles.popupBackground} onClick={onClick}>
        <div
          className={classNames(
            styles.emailConfirm,
            isSent ? styles.emailConfirm_complete : styles.emailConfirm_validation,
          )}
        >
          <ValidationBlock
            validationBlockTitle={validationBlockTitle}
            validationBlockWarning={validationBlockWarning}
            isVisible={isValidationBlockVisible}
            onValidationSuccess={onValidationSuccess}
            onValidationFailure={onValidationFailure}
          />
          <CompletedRegistrationBlock
            isAfterWeb={isAfterWeb}
            isCourseRegistrationCompleted={isCourseRegistrationCompleted}
          />
          <div className={styles.emailConfirm_closeButton} onClick={onClose} />
        </div>
      </div>
    </CSSTransition>
  );
}

export { ConfirmPopup };
